import React from "react";
import { renderTextWithLinks } from "../utlis/letterUtils";

export default function DocumentBody({ content }) {
    console.log("Rendering DocumentBody with content:", content);
    return (
        <div className="text-justify shrink-0" style={{ minWidth: 0, width: "100%" }}>
            {typeof content === "string"
        ? content.split("\n").map((line, i) => (
            <p
              key={i}
              className="mb-2 break-inside-avoid min-h-[1em]"
              style={{
                whiteSpace:    "pre-wrap",   // preserve intentional whitespace
                wordBreak:     "break-word", // break long unbroken strings
                overflowWrap:  "break-word", // cross-browser fallback
                minWidth:      0,
              }}
            >
              {line ? renderTextWithLinks(line) : "\u00A0"}
            </p>
          ))
        : content}
        </div>
    );
}